const HTMLBeta = () => <span data-component="beta" />;

export default HTMLBeta;
